export class SearchMatchFilter {
  public field: string;
  public value: string;
}
